import { useEffect, useState } from 'react';
import PaginacaoUI from '../components/common/Paginacao';

export default function usePaginacao(itens, porPagina = 10) {
  const [pagina, setPagina] = useState(1);
  const totalPaginas = Math.max(1, Math.ceil(itens.length / porPagina));

  useEffect(() => {
    if (pagina > totalPaginas) setPagina(1);
  }, [itens.length, totalPaginas, pagina]);

  const paginados = itens.slice((pagina - 1) * porPagina, pagina * porPagina);

  const Paginacao = () => <PaginacaoUI pagina={pagina} totalPaginas={totalPaginas} onChange={setPagina} />;

  return { paginados, pagina, totalPaginas, Paginacao };
}
